import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { TradeLanesMap } from "@/components/TradeLanesMap";
import { Services } from "@/components/Services";
import { PersonalGoods } from "@/components/PersonalGoods";
import { QuoteForm } from "@/components/QuoteForm";
import { CustomsFiling } from "@/components/CustomsFiling";
import { TrustBar } from "@/components/TrustBar";
import { ComplianceDisclaimer } from "@/components/ComplianceDisclaimer";
import { CompanyProfile } from "@/components/CompanyProfile";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-cream min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <TradeLanesMap />
      <CompanyProfile />
      <PersonalGoods />
      <QuoteForm />
      <CustomsFiling />
      <TrustBar />
      <ComplianceDisclaimer />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
